export class GenerateErrors {
  static get_error_id(error: any) {
    return error?.error?.error?.details?.id != undefined
      ? error?.error?.error?.details?.id
      : "error";
  }

  static check_if_is_custom_error(error: any) {
    return (
      error?.error?.error?.details?.id != undefined &&
      error?.error?.error?.details?.message != undefined
    );
  }

  static get_message_error(error: any) {
    let message = "Une érreur est survenue";
    if (
      error?.error?.error?.details?.id != undefined &&
      error?.error?.error?.details?.message != undefined
    ) {
      message = error?.error?.error?.details?.message;
    }
    return message;
  }
}
